const SessionType = {
    Game:               { key: 'Game', name: 'Game'},
    PitchingSession:    { key: 'PitchingSession', name: 'Bullpen'},
    BattingSession:     { key: 'BattingSession', name: 'Batting Practice'},
    GamePractice:       { key: 'GamePractice', name: 'Scrimmage'},
};

export default SessionType;